import { Component, OnInit } from '@angular/core';
import { PurchaseOrder } from 'src/app/models/purchase-order';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { PurchaseOrderService } from 'src/app/services/purchase-order.service';
import { environment } from 'src/environments/environment';
import { MailerService } from 'src/app/services/mailer.service';
import { Supplier } from 'src/app/models/supplier';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SupplierService } from 'src/app/services/supplier.service';

@Component({
  selector: 'app-purchase-order-single',
  templateUrl: './purchase-order-single.component.html',
  styleUrls: ['./purchase-order-single.component.css']
})
export class PurchaseOrderSingleComponent implements OnInit {
  order: PurchaseOrder = new PurchaseOrder();
  actualUser:string = "";
  canDelete:boolean = false;
  supplier:Supplier = null;

  loading:boolean = false;
  canAuthorize:boolean = false;
  quitarPermisoOrdenCompra:boolean = false;

  constructor( actRoute:ActivatedRoute, private orderServ:PurchaseOrderService, private auth:AuthService, private toastr:ToastrManager, private mailer:MailerService, private modal:NgbModal, private supplierServ:SupplierService ) {
    actRoute.params.subscribe(params => {
      this.loadOrder(params.id);
    });
  }

  ngOnInit() {}

  getTotal() {
    return this.order.lines.filter(ln => ln.status != 'Cancelado')
      .map(line => ((line.quantity * line.unit_price) - ((line.quantity * line.unit_price) * (line.discount / 100))) * (line.iva*1 + 1))
      .reduce((act, ant) => act + ant, 0);
  }

  authorize() {
    this.loading = true;
    this.orderServ.authorizeOrder(this.order).then(order => {
      this.order = order;
      this.perms(order);
      this.loading = false;
    }).catch(e => {
      this.toastr.errorToastr("La orden no puede ser autorizada! tal vez se haya eliminado.");
      this.loading = false;
    });
  }

  openModal(m) {
    if (!this.supplier) {
      this.loading = true;
      this.supplierServ.getSupplier(this.order.supplier_id)
        .then(supplier => {
          this.supplier = supplier;
          this.modal.open(m, {size: 'lg'});
          this.loading = false;
        });
    } else {
      this.modal.open(m, {size: 'lg'});
    }
  }

  delete(line = 0) {
    let promise:Promise<any>
    if (line) {
      promise = this.orderServ.deleteOrder({
        order_id: this.order.id,
        order_line_id: line,
      });
    } else {
      promise = this.orderServ.deleteOrder({
        order_id: this.order.id
      });
    }

    this.loading = true;
    promise.then(resp => {
      if (resp.destroyed) {
        this.toastr.successToastr("¡Elemento eliminado correctamente!");
        this.loadOrder(this.order.id);
      } else {
        this.toastr.errorToastr("¡No puede ser eliminado!");
        this.loading = false;
      }
    });
  }

  loadOrder(id) {
    this.loading = true;
    this.orderServ.getOrder(id).then(order => {
      this.order = order;
      this.actualUser = `${this.order.user.name} ${this.order.user.last_name}`;
      this.loading = false;

      this.perms(order);
    });
  }

  perms(doc) {
    this.canDelete = this.auth.can('destroy-purchase-order') && !doc.authorized;
    this.canAuthorize = this.auth.can('authorize-purchase-order') && doc.status == 'Abierto';
  }

  pdf() { window.open(environment.baseUrl + '/pdf/purchases/order/' + this.order.id, '_blank'); }

  pdfH(){ window.open(environment.baseUrl + '/pdf/purchases/orderH/' + this.order.id, '_blank'); }

  sendEmail() {
    this.loading = true;

    let sender = this.mailer.postOrder(this.order, this.supplier.email);

      sender.then(resp => {
        this.toastr.successToastr("Se envió el correo correctamente!!");
        this.loading = false;
      }).catch(err => {
        this.toastr.errorToastr("Error al tratar de enviar el correo, contacta al administrador!!");
        this.loading = false;
      });
  }

}
